import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { Navbar } from "./components/Common/Navbar";
import { Footer } from "./components/Common/Footer";

import AOS from "aos";
import "aos/dist/aos.css";
import { Home } from "./pages/Home";
import { AboutUs } from "./pages/AboutUs";
import { Blogs } from "./pages/Blogs";
import { Services } from "./pages/Services";
import { Policy } from "./pages/Policy";
import { Workshops } from "./pages/Workshops";
import { SingleBlog } from "./pages/SingleBlog";
import { Facts } from "./pages/Facts";
import { Ebooks } from "./pages/Ebooks";
import { FAQ } from "./pages/Faq";
import { Quiz } from "./pages/Quix";
import { StartQuiz } from "./pages/StartQuiz";
import { Pathway } from "./pages/Pathway";
import Loader from "./components/Loader/Loader";
import { PdfViewer } from "./pages/PdfViewer";
import { Error404 } from "./pages/Error404";

import ChatbotWidget from "./components/Chatbot/ChatbotWidget";
import ScrollToTop from "./components/Common/ScrollToTop";
import Chatbot from "react-chatbot-kit";
import config from "./components/Chatbot/config";
import MessageParser from "./components/Chatbot/MessageParser";
import ActionProvider from "./components/Chatbot/ActionProvider";
import { FormPage } from "./pages/Forms";
import  ScrollToTopButton  from "./components/ScrollToTopButton";

const AppLayout = ({ children }) => {
  const location = useLocation();
  const noLayoutRoutes = ["/quiz/:id", "/pdf-viewer", "/chatbot"]; // Add specific routes that need no layout.

  const hideLayout = noLayoutRoutes.some((route) =>
    location.pathname.match(
      new RegExp(`^${route.replace(":id", "\\w+").replace(":fileUrl", ".+")}$`)
    )
  );

  return (
    <div>
      {!hideLayout && <Navbar />}
      <div>{children}</div>
      {!hideLayout && <Footer />}
    </div>
  );
};

const AppContent = () => {
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();

  // List of paths where chatbot should be hidden
  const chatbotDisabledRoutes = [
    "/quiz",
    "/quiz/:id",
    "/pdf-viewer",
    "/chatbot",
  ];

  // Function to match dynamic routes (like /quiz/:id)
  const isChatbotDisabled = chatbotDisabledRoutes.some((route) =>
    location.pathname.match(
      new RegExp(`^${route.replace(":id", "\\w+").replace(":fileUrl", ".+")}$`)
    )
  );

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease",
      once: true,
    });
  }, []);

  useEffect(() => {
    if (location.pathname === "/" || location.pathname === "/home") {
      setIsLoading(true);
      const timeout = setTimeout(() => setIsLoading(false), 2000);
      return () => clearTimeout(timeout);
    } else {
      setIsLoading(false);
    }
  }, [location]);

  return (
    <>
      {isLoading ? (
        <div className="loader">
          <Loader />
        </div>
      ) : (
        <AppLayout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home-2" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/services" element={<Services />} />
            <Route path="/workshops" element={<Workshops />} />
            <Route path="/icf-pathway" element={<Pathway />} />
            <Route path="/resources" element={<Blogs />} />
            <Route path="/policy" element={<Policy />} />
            <Route path="/resource/:id" element={<SingleBlog />} />
            <Route path="/facts" element={<Facts />} />
            <Route path="/ebooks" element={<Ebooks />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/quiz" element={<Quiz />} />
            <Route path="/quiz/:id" element={<StartQuiz />} />
            <Route path="/forms" element={<FormPage />} />
            <Route path="/pdf-viewer" element={<PdfViewer />} />
            <Route
              path="/chatbot"
              element={
                <div style={{ height: "100vh" }}> 
                  <Chatbot
                    config={config}
                    messageParser={MessageParser}
                    actionProvider={ActionProvider}
                  />
                </div>
              }
            />
            <Route path="*" element={<Error404 />} />
          </Routes>
          {!isChatbotDisabled && <ChatbotWidget />}
          <ScrollToTopButton />
        </AppLayout>
      )}
    </>
  );
};

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <AppContent />
    </Router>
  );
};

export default App;